<script lang="ts">
  import { getContext } from "svelte";
  import Icon from "../../../../../common/icons/Icon.svelte";
  import {
    PlanTier,
    getPlanBaseCost,
  } from "../../../../../../app/store/store-plan";
  import { getPlanTierIcon } from "../../../utils";
  import DropdownWrapper from "../../../../../common/dropdown/DropdownWrapper.svelte";
  import PlanTierItem from "./PlanTierItem.svelte";
  import { keyControlAction } from "../../../../../common/key-control/listKeyControl";
  import type {
    KeyControlConfig,
    KeyControlActionOptions,
  } from "../../../../../common/key-control/listKeyControl";
  import type { CreateNewAccountContext } from "../../../type";
  import { CREATE_NEW_ACCOUNT_CONTEXT_NAME } from "../../../utils";
  import { plansDataStore } from "../../../../../../app/store/store-plan";

  export let planTier: PlanTier;

  const context: CreateNewAccountContext = getContext(
    CREATE_NEW_ACCOUNT_CONTEXT_NAME
  );
  const planTierList: PlanTier[] = ["standard", "business", "professional"];
  let pages = context.pages;
  let show: boolean = false;
  let planCost: number;
  let keyControlList: KeyControlConfig[] = [];
  let keyControlOptions: KeyControlActionOptions = {
    configList: keyControlList,
  };

  function toggleOpenDropdown() {
    show = !show;
  }

  function changePlanTier(value: PlanTier) {
    planTier = value;
    show = false;
  }

  $: if ($pages && $plansDataStore) {
    planCost = getPlanBaseCost(
      context.getAccountType(),
      planTier,
      context.getPlanDuration()
    );
  }
</script>

<DropdownWrapper bind:show>
  <div
    class="relative w-full h-11 border border-solid border-light-100 rounded cursor-pointer"
    on:click={toggleOpenDropdown}
    on:keydown
    slot="button"
  >
    <div class="flex flex-row items-center h-full pl-[18px] space-x-2">
      <Icon icon={getPlanTierIcon(planTier)} size="20px" />

      <div>
        <span class="text-dark-200 capitalize">{planTier}</span>
        <span class="text-dark-50">(${planCost})</span>
      </div>
    </div>

    <div
      class="absolute top-0 bottom-0 right-[18px] flex flex-row items-center"
    >
      <Icon icon="arrow-down" width="12px" height="6px" />
    </div>
  </div>

  <div class="dropdown" use:keyControlAction={keyControlOptions} slot="content">
    {#each planTierList as tier, index}
      <PlanTierItem planTier={tier} {changePlanTier} {keyControlList} {index} />
    {/each}
  </div>
</DropdownWrapper>

<style lang="postcss">
  .dropdown {
    @apply w-full rounded py-1.5 bg-white;
    box-shadow: 0px 5px 20px rgba(55, 84, 170, 0.16);
  }

  :global(.summary .dropdown-container) {
    width: min(calc(100% - 84px), 280px);
  }
</style>
